import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { App } from '@klp/core/app/App';

import { KlpTheme, EnvironmentIndicator } from '@klp/design';

import './index.scss';
import { rootStore } from './store';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { SignalRProvider } from '@klp/contractregistration';
import {
    contractToRegistrationApiName,
    hubEndpoint,
} from '@klp/contractregistration/config';
import { AppParamsProvider } from './packages/appParams/AppParamsContext';
import { Layout } from '@klp/layout';
import { ErrorHandler } from '@klp/core/app';
import { AuthorisedRoutes, UnauthorisedRoutes } from './routing';
import { BreadcrumbProvider } from '@klp/breadcrumbs/BreadcrumbsContext';

import { WebappAuthProvider } from '@klpkonsern/auth-core';
import { SessionExpiryModal } from '@klp/auth';
import { DevRoleSelector } from '@klp/auth/devRole';
import { Toast } from '@klpkonsern/ui';
import '@klpkonsern/ui/dist/style.css';
import './i18n/config';

ReactDOM.render(
    <BrowserRouter>
        <Provider store={rootStore}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <SignalRProvider
                    apiName={contractToRegistrationApiName}
                    endpoint={hubEndpoint}
                >
                    <AppParamsProvider>
                        <BreadcrumbProvider>
                            <Toast />
                            <KlpTheme>
                                <EnvironmentIndicator />
                                <DevRoleSelector />
                                <WebappAuthProvider
                                    config={{
                                        components: {
                                            SessionExpiryModal,
                                        },
                                    }}
                                >
                                    <App>
                                        <Layout>
                                            <ErrorHandler>
                                                <UnauthorisedRoutes />
                                                <AuthorisedRoutes />
                                            </ErrorHandler>
                                        </Layout>
                                    </App>
                                </WebappAuthProvider>
                            </KlpTheme>
                        </BreadcrumbProvider>
                    </AppParamsProvider>
                </SignalRProvider>
            </MuiPickersUtilsProvider>
        </Provider>
    </BrowserRouter>,
    document.getElementById('appRoot') as HTMLElement,
);

// Register service worker for caching (only in production builds)
// Use build-time variable instead of runtime process.env check
const isProduction =
    typeof process !== 'undefined'
        ? process.env.NODE_ENV === 'production'
        : !window.location.hostname.includes('localhost'); // Fallback: assume production if not localhost

if (
    'serviceWorker' in navigator &&
    isProduction &&
    !window.location.hostname.includes('localhost') &&
    window.location.protocol === 'https:'
) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/sw.js')
            .then((_registration) => {
                // Service worker registered successfully
            })
            .catch((_registrationError) => {
                // Service worker registration failed
            });
    });
}
